import React from "react";

const ProvinceAndCity = ({
                           sendData,
                           setSendData,
                           initialData,
                           componentData,
                           setComponentData,
                         }) => {
  return (
    <div className="solid-dyna-input grid-row">
      <div>
        <label htmlFor="sendData__province">استان</label>
        <input
          id={'sendData__province'}
          type="text"
          className=""
          placeholder="استان"
          value={sendData.province}
          onChange={(e) => setSendData({province: e.target.value.trim()})}
          // required
          list="provinceListFactor"
        />
      </div>
      <datalist id="provinceListFactor">
        {initialData.provinceList.map((v, index) => (
          <option key={index} value={v}/>
        ))}
      </datalist>
      <div>
        <label htmlFor="sendData__province">شهر</label>
        <input
          type="text"
          className=""
          placeholder="شهر"
          value={sendData.city}
          onChange={(e) => setSendData({city: e.target.value})}
          // required
          list="cityListFactor"
        />
      </div>
      <datalist id="cityListFactor">
        {initialData.cityList.map((v, index) => (
          <option key={index} value={v}/>
        ))}
      </datalist>
    </div>
  );
};

export default ProvinceAndCity;
